import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { deleteKeysObject, removeDBObjectKeys, tsValidateResult } from '@nu-art/ts-common';
export class ModuleFE_QuaiProtoItem extends ModuleFE_BaseApi {
    minimalAssertionValidator;
    constructor(dbDef, defaultDispatcher, minimalAssertionValidator, version) {
        super(dbDef, defaultDispatcher, version);
        this.minimalAssertionValidator = minimalAssertionValidator;
    }
    validateInternal(_instance) {
        const getGeneratedProps = () => this.dbDef.generatedProps ?? [];
        const instance = deleteKeysObject(removeDBObjectKeys(_instance), getGeneratedProps());
        const result = tsValidateResult(instance, this.minimalAssertionValidator);
        if (result)
            this.onValidationError(_instance, result);
        return;
    }
}
//# sourceMappingURL=ModuleFE_QuaiProtoItem.js.map